var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"parallaxer-section"},[_vm._t("layers")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }